import { ImageSizes } from 'features/image/ImageSizes'
import PropTypes from 'prop-types'

const ImageUploadGuidelines = ({
  allowImageSizes = [
    ImageSizes['450x450'],
    ImageSizes['348x230'],
    ImageSizes['1200x380'],
  ],
}) => (
  <>
    <strong className="reform_tit_filesize">파일형식</strong>
    <ul className="reform_list_filesize">
      <li>JPG, JPEG, PNG</li>
    </ul>
    <strong className="reform_tit_filesize">사이즈/용량</strong>
    <ul className="reform_list_filesize">
      {allowImageSizes.map(({ width, height, size }) => (
        <li key={`${width}x${height}`}>
          <p className="reform_desc_filesize">
            <span className="screen_out">사이즈</span>
            {`${width}x${height}`}
          </p>
          <p className="reform_desc_filekb">
            <span className="screen_out">용량</span> {size}
          </p>
        </li>
      ))}
    </ul>
  </>
)
ImageUploadGuidelines.propTypes = {
  allowImageSizes: PropTypes.arrayOf(
    PropTypes.oneOf(Object.values(ImageSizes))
  ),
}
export default ImageUploadGuidelines
